export default __webpack_public_path__ + "static/media/logo.824c6407.svg";